var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15.001,
    viewBox: "0 0 19 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1436.18,576.725h-15.721a1.608,1.608,0,0,0-1.151.486,1.686,1.686,0,0,0-.478,1.193l-.012,11.64a1.679,1.679,0,0,0,.483,1.193,1.617,1.617,0,0,0,1.154.488h15.723a1.633,1.633,0,0,0,1.157-.486,1.675,1.675,0,0,0,.483-1.193V578.407a1.68,1.68,0,0,0-.482-1.194A1.622,1.622,0,0,0,1436.18,576.725Zm.5,13.819h-16.714V583h16.714Zm0-9.455h-16.714v-3.182h16.714Z",
    transform: "translate(-1418.818 -576.725)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.c373d1040e60ea2ee9ebee61ca374e10.svg";
export { ForwardRef as ReactComponent };